import FitPulseLogo from "./FitPulseLogo";

const Footer = () => {
  return (
    <footer data-testid="footer-section" className="bg-[#F5F5F5] py-10 sm:py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6 mb-8">
          {/* Left */}
          <div className="flex items-center gap-2.5">
            <FitPulseLogo size={22} />
            <div>
              <span className="text-sm font-semibold text-[#0D0D0D]">FitPulse</span>
              <span className="text-xs text-[#999] ml-1.5">by Zevora Labs</span>
            </div>
          </div>

          {/* Center */}
          <a
            href="https://zevoralabs.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-[#666] hover:text-[#0D0D0D] transition-colors"
            data-testid="footer-website-link"
          >
            zevoralabs.com
          </a>

          {/* Right */}
          <div className="flex items-center gap-4 text-sm text-[#666]">
            <a
              href="mailto:hello@zevoralabs.com"
              className="hover:text-[#0D0D0D] transition-colors"
              data-testid="footer-email-link"
            >
              hello@zevoralabs.com
            </a>
            <span className="text-[#D0D0D0]">·</span>
            <a
              href="https://zevoralabs.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#0D0D0D] transition-colors"
              data-testid="footer-privacy-link"
            >
              Privacy Policy
            </a>
          </div>
        </div>

        <div className="border-t border-[#E5E5E5] pt-6 text-center">
          <p className="text-xs text-[#999]">&copy; 2026 Zevora Labs. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
